/**
 * CallFlows Page
 *
 * Main page for CallFlow management - shows list view.
 */

import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../dashboard/layout/DashboardLayout';
import { CallFlowList } from '../callflow/CallFlowList';
import { useOrganization } from '@/App';

export default function CallFlowsPage() {
  const { currentOrganization } = useOrganization();
  const navigate = useNavigate();

  if (!currentOrganization) {
    return (
      <DashboardLayout activeItem="CallFlows">
        <div className="text-center py-12 text-muted-foreground">
          Please select an organization to view CallFlows
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout activeItem="CallFlows">
      <CallFlowList
        organizationId={currentOrganization.id}
        onViewDetails={(id) => navigate(`/callflows/${id}`)}
      />
    </DashboardLayout>
  );
}
